import React from "react";
import {
    RadioGroup,
    Radio,
    FormControlLabel,
    TextField,
    Select,
    MenuItem,
    Typography,
} from "@material-ui/core";
import { ErrorMessage } from "formik";
import dateFnsFormat from "date-fns/format";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";

const ApplicantDto = (props) => {
    return (
        <div className="form-section-root">
            <div className="form-row form-header-row">
                <div className="form-group">
                    <Typography className="normal-text">
                        <b>APPLICANT DETAILS</b>
                    </Typography>
                </div>
            </div>
            <div className="form-row">
                <div className="form-group radio-div">
                    <label>How do you want to submit your PAN application documents? <Imp /></label>
                    <RadioGroup className="form-radio-group"
                        value={props.values.applicantDto.applnMode}
                        name="applicantDto.applnMode"
                        onChange={e => { 
                            props.setFieldValue("applicantDto.applnMode", e.target.value);
                            switch(e.target.value) {
                                case "E": {
                                    props.setFieldValue("otherDetails.addrForCommunication", "O");
                                    break;
                                }
                                case "K": {
                                    props.setFieldValue("otherDetails.addrForCommunication", "R");
                                    props.values.otherDetails.raValue != "" && 
                                    props.setFieldValue("otherDetails.raValue", "")
                                    break;
                                }
                                default: {
                                    props.setFieldValue("otherDetails.addrForCommunication", "R");
                                    props.values.otherDetails.raValue != "" && 
                                    props.setFieldValue("otherDetails.raValue", "")
                                    break;
                                }
                            }
                        }}
                    >
                        {applicationModes.map((val, idx) =>
                            <FormControlLabel
                                value={val.value}
                                label={val.label}
                                key={idx}
                                control={<Radio color="secondary" />}
                            />
                        )}
                    </RadioGroup>
                </div>
            </div>
            <div className="form-row flex-row">
                <div className="form-group radio-div col-25">
                    <label>Whether Physical PAN Card is required?</label>
                    <RadioGroup className="form-radio-group"
                        value={props.values.otherDetails.phyPanIsReq}
                        name="otherDetails.phyPanIsReq"
                        onChange={e => { props.setFieldValue("otherDetails.phyPanIsReq", e.target.value) }}
                    >
                        <FormControlLabel
                            value="Y"
                            label={`Yes (Fees applicable)`}
                            control={<Radio color="secondary" />}
                        />
                        <FormControlLabel
                            value="N"
                            label={`No`}
                            control={<Radio color="secondary" />}
                        />
                    </RadioGroup>
                </div>
                <div className="form-group text-inp col-25">
                    <label>Date of birth <Imp/></label>
                    <MuiPickersUtilsProvider
                        utils={DateFnsUtils}
                    >
                        <KeyboardDatePicker
                            name={`applicantDto.dobDisplay`}
                            inputVariant="outlined"
                            autoOk={true}
                            value={props.values.applicantDto.dobDisplay}
                            onChange={(date) => {
                                props.setFieldValue(`applicantDto.dob`, dateFnsFormat(date, "dd/MM/yyyy"));
                                props.setFieldValue(`applicantDto.dobDisplay`, date);
                            }}
                            format="dd MMM yyyy"
                            KeyboardButtonProps={{
                                "aria-label": "change date",
                            }}
                            style={{ width: "100%" }}
                        />

                    </MuiPickersUtilsProvider>
                    {/* <CustomDatePicker
                        showDisabledMonthNavigation
                        name={`applicantDto.dobDisplay`}
                        className="form-date-picker"
                        customInput={
                            <TextField id="standard-basic"
                                variant="outlined"
                                color="secondary"
                                fullWidth
                            />
                        }
                        selected={props.values.applicantDto.dobDisplay}
                        onChange={(newDate) => {
                            props.setFieldValue(`applicantDto.dob`, dateFnsFormat(newDate, "dd/MM/yyyy"));
                            props.setFieldValue(`applicantDto.dobDisplay`, newDate);
                        }}
                        dateFormat="dd MMM yyyy"
                        monthsShown={2}
                    /> */}
                    <ErrorMessage
                        name={`applicantDto.dob`}
                        component="div"
                        className="error"
                    />
                </div>
            </div>
            {props.values.applicantDto.appliType == "CR" &&
                <div className="form-row">
                    <div className="form-group input-div">
                        <label>Permanent Account Number (PAN) <Imp /></label>
                        <TextField
                            value=""
                            name="applicantDto.pan"
                            variant="outlined"
                        />
                    </div>
                </div>}
            <div className="form-row flex-row gap-10">
                <div className="form-group select-inp col-25 flex-row gap-10">
                    <div className="col-50">
                        <label>Gender <Imp/></label>
                        <Select
                            value={props.values.applicantDto.gender}
                            name="applicantDto.gender"
                            fullWidth
                            variant="outlined"
                            color="secondary"
                            onChange={e => {
                                props.setFieldValue("applicantDto.gender", e.target.value);
                            }}
                        >
                            <MenuItem value="M">Male</MenuItem>
                            <MenuItem value="F">Female</MenuItem>
                            <MenuItem value="T">Trans</MenuItem>
                        </Select>
                        <ErrorMessage
                            name={`applicantDto.gender`}
                            component="div"
                            className="error"
                        />
                    </div>
                    <div className="col-50">
                        <label>Title <Imp/></label>
                        <Select
                            value={props.values.applicantDto.title}
                            name="applicantDto.title"
                            fullWidth
                            variant="outlined"
                            color="secondary"
                            onChange={e => {
                                props.setFieldValue("applicantDto.title", e.target.value);
                            }}
                        >
                            <MenuItem value={1}>Shri</MenuItem>
                            <MenuItem value={2}>Smt.</MenuItem>
                            <MenuItem value={3}>Kumari</MenuItem>
                        </Select>
                        <ErrorMessage
                            name={`applicantDto.title`}
                            component="div"
                            className="error"
                        />
                    </div>
                </div>
                <div className="form-group text-inp col-25">
                    <label>First Name <Imp/></label>
                    <TextField
                        fullWidth
                        value={props.values.applicantDto.firstName}
                        color="secondary"
                        variant="outlined"
                        name="applicantDto.firstName"
                        onChange={e => {
                            props.setFieldValue("applicantDto.firstName", e.target.value);
                        }}
                    />
                    <ErrorMessage
                        name={`applicantDto.firstName`}
                        component="div"
                        className="error"
                    />
                </div>
                <div className="form-group text-inp col-25">
                    <label>Middle Name</label>
                    <TextField
                        fullWidth
                        value={props.values.applicantDto.middleName}
                        color="secondary"
                        variant="outlined"
                        name="applicantDto.middleName"
                        onChange={e => {
                            props.setFieldValue("applicantDto.middleName", e.target.value);
                        }}
                    />
                </div>
                <div className="form-group text-inp col-25">
                    <label>Last Name <Imp/></label>
                    <TextField
                        fullWidth
                        value={props.values.applicantDto.lastName}
                        color="secondary"
                        variant="outlined"
                        name="applicantDto.lastName"
                        onChange={e => {
                            props.setFieldValue("applicantDto.lastName", e.target.value);
                        }}
                    />
                    <ErrorMessage
                        name={`applicantDto.lastName`}
                        component="div"
                        className="error"
                    />
                </div>
            </div>
            <div className="form-row flex-row gap-10">
                <div className="form-group col-25 flex-row gap-10">
                    <div className="col-50 radio-div">
                        <label title="Known by other name?">Other Name</label>
                        <RadioGroup className="form-radio-group no-wrap"
                            value={props.values.applicantDto.knownByOtherName}
                            name="applicantDto.knownByOtherName"
                            onChange={e => { props.setFieldValue("applicantDto.knownByOtherName", e.target.value) }}
                        >
                            <FormControlLabel
                                value="Y"
                                label={`Yes`}
                                control={<Radio color="secondary" />}
                            />
                            <FormControlLabel
                                value="N"
                                label={`No`}
                                control={<Radio color="secondary" />}
                            />
                        </RadioGroup>
                        <ErrorMessage
                            name={`applicantDto.knownByOtherName`}
                            component="div"
                            className="error"
                        />
                    </div>
                    {props.values.applicantDto.knownByOtherName == "Y" &&
                        <div className="col-50 select-inp">
                            <label>Title (Other)</label>
                            <Select
                                value={props.values.applicantDto.title}
                                name="applicantDto.otherTitle"
                                fullWidth
                                variant="outlined"
                                color="secondary"
                                onChange={e => {
                                    props.setFieldValue("applicantDto.title", e.target.value);
                                }}
                            >
                                <MenuItem value={1}>Shri</MenuItem>
                                <MenuItem value={2}>Smt.</MenuItem>
                                <MenuItem value={3}>Kumari</MenuItem>
                            </Select>
                            <ErrorMessage
                                name={`applicantDto.otherTitle`}
                                component="div"
                                className="error"
                            />
                        </div>
                    }
                </div>
                {props.values.applicantDto.knownByOtherName == "Y" && <>
                    <div className="form-group text-inp col-25">
                        <label>First Name (Other)</label>
                        <TextField
                            fullWidth
                            value={props.values.applicantDto.otherFirstName}
                            color="secondary"
                            variant="outlined"
                            name="applicantDto.otherFirstName"
                            onChange={e => {
                                props.setFieldValue("applicantDto.otherFirstName", e.target.value);
                            }}
                        />
                        <ErrorMessage
                            name={`applicantDto.otherFirstName`}
                            component="div"
                            className="error"
                        />
                    </div>
                    <div className="form-group text-inp col-25">
                        <label>Middle Name (Other)</label>
                        <TextField
                            fullWidth
                            value={props.values.applicantDto.otherMiddleName}
                            color="secondary"
                            variant="outlined"
                            name="applicantDto.otherMiddleName"
                            onChange={e => {
                                props.setFieldValue("applicantDto.otherMiddleName", e.target.value);
                            }}
                        />
                    </div>
                    <div className="form-group text-inp col-25">
                        <label>Last Name (Other)</label>
                        <TextField
                            fullWidth
                            value={props.values.applicantDto.otherLastName}
                            color="secondary"
                            variant="outlined"
                            name="applicantDto.otherLastName"
                            onChange={e => {
                                props.setFieldValue("applicantDto.otherLastName", e.target.value);
                            }}
                        />
                        <ErrorMessage
                            name={`applicantDto.otherLastName`}
                            component="div"
                            className="error"
                        />
                    </div>
                </>}
            </div>
            <div className="form-row flex-row gap-10">
                <div className="form-group radio-div col-24">
                    <label>Consent</label>
                    <RadioGroup className="form-radio-group"
                        value={props.values.applicantDto.consent}
                        name="applicantDto.consent"
                        onChange={e => { props.setFieldValue("applicantDto.consent", e.target.value) }}
                    >
                        <FormControlLabel
                            value="yes"
                            label={`Yes`}
                            control={<Radio color="secondary" />}
                        />
                        <FormControlLabel
                            value="no"
                            label={`No`}
                            control={<Radio color="secondary" />}
                        />
                    </RadioGroup>
                    <ErrorMessage
                        name={`applicantDto.consent`}
                        component="div"
                        className="error"
                    />
                </div>
                <div className="form-group text-inp col-25">
                    <label>Name on PAN card <Imp/></label>
                    <TextField
                        fullWidth
                        value={props.values.applicantDto.nameOnPanCard}
                        color="secondary"
                        variant="outlined"
                        name="applicantDto.nameOnPanCard"
                        onChange={e => {
                            props.setFieldValue("applicantDto.nameOnPanCard", e.target.value);
                        }}
                    />
                    <ErrorMessage
                        name={`applicantDto.nameOnPanCard`}
                        component="div"
                        className="error"
                    />
                </div>
                <div className="form-group text-inp col-25">
                    <label>Name as per Aadhaar <Imp/></label>
                    <TextField
                        fullWidth
                        value={props.values.applicantDto.nameAsPerAadhar}
                        color="secondary"
                        variant="outlined"
                        name="applicantDto.nameAsPerAadhar"
                        onChange={e => {
                            props.setFieldValue("applicantDto.nameAsPerAadhar", e.target.value);
                        }}
                        disabled={props.values.applicantDto.applnMode == "K" || props.values.applicantDto.applnMode == ""}
                    />
                    <ErrorMessage
                        name={`applicantDto.nameAsPerAadhar`}
                        component="div"
                        className="error"
                    />
                </div>
            </div>
        </div>
    );
};

export default ApplicantDto;

const applicationModes = [
    {label: "Submit digitally through e-KYC", value: "K"},
    {label: "Submit scanned images through e-Sign", value: "E"},
    {label: "Forward application documents physically", value: ""}
];

const Imp = () => <span className="imp">*</span>;
